<template>
  <div>
    <div class="opening-hours box faq-box z-depth-1">
      <div class="container">
        <img class="material-icons" :src="$mobileCdn('images/icons/icon-phone-yellow.svg')" width="23" alt="Telefone">
        <span class="opening-hours__main-title">{{ $t('help.others.subtitle') }}</span>
      </div>
      <div class="opening-hours__phones">
        <div v-if="phones.majorcities" class="opening-hours__phones--left-phone">
          <p>{{ $t('common.phones.majorcities') }}</p>
          <a :href="`tel:${phones.majorcities}`">
            {{ phones.majorcities }}
          </a>
        </div>

        <div v-if="phones.othercities" class="">
          <p>{{ $t('common.phones.othercities') }}</p>
          <a :href="`tel:${phones.othercities}`">
            {{ phones.othercities }}
          </a>
        </div>
      </div>
      <div v-if="phones.intercalling" :class="[{ 'mt-30': phones.majorcities ,'opening-hours__phones-intercalling': true}]">
        <p>{{ $t('common.phones.intercalling') }}</p>
        <a :href="`tel:${phones.intercalling}`">
          {{ phones.intercalling }}
        </a>
      </div>
      <div v-if="phones.openingHours" class="opening-hours__bussines-hour">
        <p class="opening-hours__bussines-hour--main-text">
          {{ $t('common.phones.checkbusinesshour') }}:
        </p>

        <p v-if="phones.openingHours.Monday">
          <strong>{{ phones.openingHours.Monday.Title }}</strong>
          - {{ phones.openingHours.Monday.Open }}
          {{ $t('common.at') }}
          {{ phones.openingHours.Monday.Close }}
        </p>

        <p v-if="phones.openingHours.WeekDays">
          <strong>{{ phones.openingHours.WeekDays.Title }}</strong>
          - {{ phones.openingHours.WeekDays.Open }}
          <template v-if="phones.openingHours.WeekDays.Close">
            {{ $t('common.at') }}
            {{ phones.openingHours.WeekDays.Close }}
          </template>
        </p>

        <p v-if="phones.openingHours.Saturday">
          <strong>{{ phones.openingHours.Saturday.Title }}</strong>
          - {{ phones.openingHours.Saturday.Open }}
          {{ $t('common.at') }}
          {{ phones.openingHours.Saturday.Close }}
        </p>

        <p v-if="phones.openingHours.Sunday">
          <strong>{{ phones.openingHours.Sunday.Title }}</strong>
          - {{ phones.openingHours.Sunday.Open }}
          {{ $t('common.at') }}
          {{ phones.openingHours.Sunday.Close }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OpeningHours',

  props: {
    phones: {
      required: true,
      type: Object
    }
  }
}

</script>
<style lang="scss" scoped>
.opening-hours {
  box-shadow: none;
  color: #13100D;

  &__main-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  &__phones {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    line-height: 10px;

    &--left-phone {
      border-right: 1px solid #DADADA;
      padding-right: 40px;
    }

    p, a {
      color: $color-black;
      font-weight: 400;
      font-size: 14px;
    }

  }

  &__phones-intercalling {
    line-height: 10px;

    &.mt-30 {
      margin-top: 30px;
    }

    p, a {
      color: $color-black;
      font-weight: 400;
      font-size: 14px;
    }
  }

  &__bussines-hour {
    margin-top: 24px;

    &--main-text {
      margin-bottom: 10px!important;
    }

    p {
      color: #000000;
      margin: 5px 0;
    }
  }
}
</style>
